import React from 'react';
import { motion } from 'framer-motion';

const ContactHero: React.FC = () => (
  <section
    className="w-full relative overflow-hidden rounded-bl-[16px] rounded-br-[16px]"
    style={{ background: 'linear-gradient(180deg, var(--brand-blue) 0%, var(--brand-blue-dark) 100%)' }}
  >
    <div className="pointer-events-none absolute inset-0 overflow-hidden opacity-30" aria-hidden>
      <div
        className="absolute -right-32 -top-32 h-[400px] w-[400px] rounded-full"
        style={{ background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)' }}
      />
    </div>

    <div className="layout-container relative z-10 pt-10 pb-10 lg:pt-12 lg:pb-24">
      <motion.div
        initial={{ opacity: 0, x: -24 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className="max-w-[640px]"
      >
        <h1 className="font-title font-medium text-white text-[42px] sm:text-[56px] lg:text-[64px] leading-[1.05] tracking-tight">
          Let's Talk
        </h1>
        <p className="mt-4 max-w-[500px] font-description font-normal text-[16px] leading-[1.6] text-brand-blue-light">
          Tell us what you're looking for and we'll point you in the right direction.
        </p>
      </motion.div>
    </div>
  </section>
);

export default ContactHero;
